/*
 * @Author: handiya handiya@hikvision.com.cn
 * @Date: 2023-09-12 15:50:50
 * @LastEditors: handiya handiya@hikvision.com.cn
 * @LastEditTime: 2023-12-07 15:42:40
 * @FilePath: \ep-admin-management\src\utils\request\interceptors.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 首先引入axios
import axios, { AxiosInstance } from 'axios'
import { BASE, DownloadBase } from '@/config/index'
import { sendMessage } from '@/utils'

export class Interceptors {
  instance: AxiosInstance
  constructor() {
    this.instance = axios.create({
      baseURL: BASE
      // timeout: 10000,
    })
  }
  // 初始化拦截器
  init() {
    // 请求接口拦截器
    this.instance.interceptors.request.use(
      config => {
        config.headers['ep-header-language'] = localStorage.getItem('lang') || 'en-US'
        return config
      },
      err => {
        console.error(err)
      }
    )

    // 响应拦截器
    this.instance.interceptors.response.use(
      async (response) => {
        if (response.data instanceof Blob) {

          if (response.data.type === 'application/json') {
            // 当返回下载错误的时候
            const text = await response.data.text();
            response.data = JSON.parse(text) || {};
          } else {

            return response
          }
        }
        const { code } = response.data


        if (code == 200 || code == 201) {
          return response.data
        }

        if (code == 401) {
          sendMessage({
            eventName: 'sessionExpired',
            eventData: true
          })
          return
        }
        return {
          success: false,
          failMsg: response.data.failMsg || 'Request Failed'
        }
      },
      error => {
        // console.error('eeeeeeeeeeeeerrrrrrrr', error)
        // sendMessage({
        //   eventName: 'sessionExpired',
        //   eventData: true
        // })
        return Promise.resolve(error)
      }
    )
  }
  // 返回一下
  getInterceptors() {
    this.init()
    return this.instance
  }
}
